import React, { useState, useEffect } from "react";
import { Tooltip } from "react-tooltip";
import style from "./ChangingProductId.module.css";
import classNames from "classnames";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";

interface IChangingProductId {
  onlyDesktop?: boolean;
  activeGroup: any[];
  selectedGroupId: number | null;            // это productGroupId
  setSelectedGroupId: (v: number) => void;
}

export const ChangingProductId: React.FC<IChangingProductId> = ({
  onlyDesktop = false,
  activeGroup,
  selectedGroupId,
  setSelectedGroupId
}) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const pathname = location.pathname;


  // Правила:
  // - На /orders/* и на /documents/* при смене группы — перезагрузка страницы
  // - На существующих документах /documents/*/:id — селектор отключён
  const segments = pathname.split('/').filter(Boolean);
  const isExistingDocument = (
    segments[0] === 'documents' && segments.length >= 3 && segments[2] !== 'new' && segments[2] !== 'orders'
  );
  const isExistingOrder = (
    pathname.startsWith("/orders/") && !/\/new(\/)?$/i.test(pathname)
  );
  const shouldReloadOnGroupChange = (
    (pathname.startsWith("/orders") && !isExistingOrder) ||
    (pathname.startsWith("/documents") && !isExistingDocument)
  );
  const isDisabled = isExistingDocument || isExistingOrder;

  // Если смена группы запрещена — гарантированно закрываем тултип
  useEffect(() => {
    if (isDisabled && open) {
      setOpen(false);
    }
  }, [isDisabled, open]);

  const handlePick = (productGroupId: number) => {
    if (isDisabled) return; // заблокировано на существующих документах/заказах
    setSelectedGroupId(productGroupId);

    const selected = activeGroup?.find((g: any) => g.productGroupId === productGroupId);

    // В куку кладём именно productGroupId
    Cookies.set("activeGroup", String(productGroupId), { expires: 180, path: "/" });

    if (selected?.productGroupCode) {
      Cookies.set("activeGroupCode", String(selected.productGroupCode), { expires: 180, path: "/" });
    }
    setOpen(false);

    if (shouldReloadOnGroupChange) {
      window.location.reload();
    }
  };

  const currentName =
    activeGroup.find((g: any) => g.productGroupId === selectedGroupId)?.productGroupName ??
    "Загрузка...";

  return (
    <div>
      <button
        type="button"
        data-tooltip-id={isDisabled ? undefined : "changing-product"}
        className={classNames(
          "h-6 text-sm items-center gap-1 w-[150px] flex justify-between",
          onlyDesktop ? "flex" : "hidden md:flex",
          isDisabled && "opacity-50 cursor-not-allowed"
        )}
        data-tooltip-offset={24}
        disabled={isDisabled}
      >
        <div>{currentName}</div>
        <img
          src="/icons/arrow-top.svg"
          className={classNames("block h-6 w-6 duration-200", open ? "" : "rotate-180")}
        />
      </button>

      {!isDisabled && (
        <div className="z-[1000] relative">
          <Tooltip
            id="changing-product"
            className={classNames(style.wrapperTooltip, "drop-shadow-2xl")}
            openOnClick={true}
            clickable
            noArrow
            opacity={1}
            place="bottom-end"
            afterShow={() => setOpen(true)}
            afterHide={() => setOpen(false)}
          >
            <div
              className={classNames(
                style.tooltip,
                "flex flex-col min-w-[208px] p-0 rounded-lg relative left-[21px] overflow-hidden",
              )}
            >
              <span className="flex h-10 items-center pl-4 text-sm">Выберите значение</span>

              {activeGroup?.map((item: any) => {
                const isActive = selectedGroupId === item.productGroupId;
                return (
                  <button
                    key={item.productGroupId}
                    type="button"
                    onClick={() => handlePick(item.productGroupId)}
                    className={classNames(
                      "flex h-10 items-center px-4 duration-200 text-sm justify-between hover:bg-gray-100",
                      isActive && "bg-gray-100",
                    )}
                  >
                    <span>{item.productGroupName}</span>
                  </button>
                );
              })}
            </div>
          </Tooltip>
        </div>
      )}
    </div>
  );
};
